// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M.293 14.296L14.291.293c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414L1.708 15.71c-.39.39-1.024.39-1.415 0-.39-.39-.39-1.024 0-1.414z\"/> </svg> ";
// Exports
module.exports = code;